<div class="my-4 my-md-6">
    <p class="h5 text-secondary my-3 my-md-4 text-center">Acreditados por las autoridades</p>
    <div class="grillaLogosAcreditados">
        <div *ngFor="let logo of logosAcreditados">
            <img [src]="logo" width="100%">
        </div>
    </div>
</div>